import React, { Fragment, useState, useContext } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { connect } from "react-redux";
import { Sidebar, Header } from "../../layout-components";
import RefreshToken from "../../Pages/RefreshToken/RefreshToken";
import ProfileContext from "../../components/ProfileContext";
import { ThemeContext } from "../../theme/ThemeContext";
import GlobalDataContext from "../../../src/Pages/GlobalDataContext";

const LeftSidebar = (props) => {
  const { children, sidebarToggle, sidebarFixed, contentBackground } = props;
  const [open, setOpen] = React.useState(true);
  const [userProfilePic, setUserProfilePic] = useState("");
  const [userProfile, setUserProfile] = useState({});
  const [companyProfilePic, setCompanyProfilePic] = useState("");
  const [companyProfile, setCompanyProfile] = useState("");
  const [visitorStatus, setVisitorStatus] = useState("");
  const [currentTotalVisitCount, setCurrentTotalVisitCount] = useState("");
  const [visitorsNotCheckedOut, setVisitorsNotCheckedOut] = useState("");
  const [companySettings, setCompanySettings] = useState({});
  const [visitorEvents, setVisitorEvents] = useState();
  const [resendTimer, setResendTimer] = useState(false);
  const value = {
    userProfilePic,
    companyProfilePic,
    userProfile,
    companyProfile,
    visitorStatus,
    currentTotalVisitCount,
    resendTimer,
    visitorsNotCheckedOut,
    visitorEvents,
    setResendTimer,
    setVisitorStatus,
    setUserProfile,
    setUserProfilePic,
    setCompanyProfilePic,
    setCompanyProfile,
    setCurrentTotalVisitCount,
    setVisitorsNotCheckedOut,
    setVisitorEvents,
  };
  const globalData = { companySettings, setCompanySettings };
  const { darkMode } = useContext(ThemeContext);
  const onChangeSidebar = (child) => {
    setOpen(child);
  };
  return (
    <Fragment>
      <GlobalDataContext.Provider value={globalData}>
        <ProfileContext.Provider value={value}>
          <div className={clsx("app-wrapper", contentBackground)}>
            <Header />
            <div
              className={clsx(darkMode ? "app-mainn" : "app-main", {
                "app-main-sidebar-static": !sidebarFixed,
                backgroundColor: darkMode
                  ? "#021C31"
                  : "rgba(61, 73, 119, 0.04)",
              })}
            >
              <Sidebar onchange={onChangeSidebar} />
              <div>
                <div
                  className={"app-content--inner"}
                  style={{
                    backgroundColor: darkMode
                      ? "#021C31"
                      : "rgba(61, 73, 119, 0.04)",
                  }}
                >
                  <div
                    className={clsx(
                      open
                        ? darkMode
                          ? "app_container1"
                          : "app_container1"
                        : "app_container2"
                    )}
                  >
                    {children}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <RefreshToken />
        </ProfileContext.Provider>
      </GlobalDataContext.Provider>
    </Fragment>
  );
};

LeftSidebar.propTypes = {
  children: PropTypes.node,
};

const mapStateToProps = (state) => ({
  sidebarToggle: state.ThemeOptions.sidebarToggle,
  sidebarToggleMobile: state.ThemeOptions.sidebarToggleMobile,
  sidebarFixed: state.ThemeOptions.sidebarFixed,
  headerFixed: state.ThemeOptions.headerFixed,
  headerSearchHover: state.ThemeOptions.headerSearchHover,
  headerDrawerToggle: state.ThemeOptions.headerDrawerToggle,
  contentBackground: state.ThemeOptions.contentBackground,
});

export default connect(mapStateToProps)(LeftSidebar);
